import React, { ReactNode, useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import classes from "classnames";

export interface PopupProps {
  content: JSX.Element;
  children?: ReactNode;
}

const Popup = ({
  className,
  children,
  content,
  ...props
}: PopupProps & Omit<React.HTMLAttributes<HTMLDivElement>, "content">) => {
  const [visible, setVisible] = useState(false);
  const canHide = useRef(true);

  const showContent = (_e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setVisible(true);
    canHide.current = false;
    setTimeout(() => {
      canHide.current = true;
    }, 10);
  };

  useEffect(() => {
    const hideContent = (_e: any) => {
      if (canHide.current) {
        setVisible(false);
      }
    };
    document.body.addEventListener("click", hideContent);
    return () => {
      document.body.removeEventListener("click", hideContent);
    };
  }, []);

  return (
    <div
      className={classes(styles.popup, className)}
      {...props}
      onClick={(e) => showContent(e)}
    >
      {children}
      {visible && <div className={styles.content}>{content}</div>}
    </div>
  );
};

export default Popup;
